(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-login"]) return;
  try {
    
  const triggerButton = document.querySelectorAll('[data-recover]');
  const loginWrapper = document.querySelector('[data-login]');
  const forgotWrapper = document.querySelector('[data-forgot]');
  console.log(triggerButton);
  triggerButton.forEach((button) => {
    button.addEventListener('click', function (e) {
      loginWrapper.classList.toggle('hidden');
      forgotWrapper.classList.toggle('block');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  window.addEventListener('load', function () {
    document.getElementById('Search').focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  const productRecommendationsSection = document.querySelector('[data-product-recommendations]');
  const url = productRecommendationsSection.dataset.url;

  fetch(url)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const swiperContent = html.querySelector('swiper-container');

      if (swiperContent) {
        productRecommendationsSection.querySelector('swiper-container').innerHTML =
          swiperContent.innerHTML;
      }
    })
    .catch((e) => {
      console.error(e);
    });

  } catch(e) { console.error(e); }
})();
})();
